import React, { useState } from 'react';
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

function TableMessage({ tableData, withAvatar = false, showAvatar, type }) {
  const [showTable, setShowTable] = useState(false);

  // At the top inside TableMessage component
  let parsedData = [];

  try {
    const cleanedData = tableData
      .replace(/^Sample data:\s*/, '')
      .replace(/'/g, '"')
      .replace(/datetime\.datetime\(([^)]+)\)/g, (_, dateArgs) => {
        const parts = dateArgs.split(',').map((p) => p.trim());
        const [y, m, d, h = 0, min = 0] = parts;
        const isoString = new Date(y, m - 1, d, h, min).toISOString(); // ISO string
        return `"${isoString}"`;
      });

    parsedData = JSON.parse(cleanedData);
  } catch (e) {
    console.error('❌ Invalid table data format:', e);
  }

  const headers = parsedData.length > 0 ? Object.keys(parsedData[0]) : [];

  return (
    <Box
      sx={{
        pl: withAvatar && !showAvatar ? '65px' : 0,
        display: 'flex',
        flexDirection: 'row',
        my: 1,
      }}
    >
      <Box
        sx={{
          border: '1px solid lightgray',
          padding: withAvatar ? '8px 14px' : '8px 12px',
          maxWidth: withAvatar ? '75%' : '85%',
          borderRadius: '8px',
          backgroundColor: '#fafafa',
          boxShadow: 1,
          width: '100%',
        }}
      >
        <Box
          onClick={() => setShowTable(!showTable)}
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            cursor: 'pointer',
            userSelect: 'none',
          }}
        >
          <Typography variant="subtitle1" fontWeight="bold">
            {type || 'Table'}
          </Typography>
          <span>{showTable ? <ExpandLessIcon /> : <ExpandMoreIcon />}</span>
        </Box>

        {showTable && (
          <TableContainer component={Paper} sx={{ mt: 2, maxHeight: '40vh', overflow: 'auto' }}>
            <Table stickyHeader size="small">
              <TableHead>
                <TableRow>
                  {headers.map((header) => (
                    <TableCell key={header} sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>
                      {header}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {parsedData.map((row, idx) => (
                  <TableRow key={idx}>
                    {headers.map((header) => (
                      <TableCell key={header}>{row[header]}</TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Box>
    </Box>
  );
}

export default TableMessage;
